import {
  Box,
  Card,
  IconCheckmarkCircle,
  IconCrossCircle,
  IconInfoCircle,
  Text,
} from '@tocktix/pantry';
import { FunctionComponent } from 'react';

export type UserHistoryEventCardProps = {
  title: string;
  icon: 'success' | 'danger' | 'info';
  dateTime: string;
  reason?: string;
  id?: string;
  updatedByTockPatronId?: bigint;
  source?: string;
};

const UserHistoryEventCard: FunctionComponent<UserHistoryEventCardProps> = ({
  title,
  icon,
  dateTime,
  reason,
  id,
  updatedByTockPatronId,
  source,
}) => (
  <Card>
    <Card.Body>
      <Box display="flex" flexDirection="column" gap={100}>
        <Box display="flex" alignItems="center" gap={100}>
          {icon === 'success' && <IconCheckmarkCircle size={200} color="fgSuccessBase" />}
          {icon === 'danger' && <IconCrossCircle size={200} color="fgDangerBase" />}
          {icon === 'info' && <IconInfoCircle size={200} color="fgSubtle" />}
          <Text variant="bodyStrong">{title}</Text>
        </Box>
        <Text variant="bodySm" color="fgSubtle">
          {dateTime}
        </Text>
        {id ? (
          <Text variant="bodySm">
            <Text variant="bodySmStrong" as="span">
              ID:{' '}
            </Text>
            {id}
          </Text>
        ) : null}
        {reason ? (
          <Text variant="bodySm">
            <Text variant="bodySmStrong" as="span">
              Reason:{' '}
            </Text>
            {reason}
          </Text>
        ) : null}
        {updatedByTockPatronId != null ? (
          <Text variant="bodySm">
            <Text variant="bodySmStrong" as="span">
              Updated by Tock Patron ID:{' '}
            </Text>
            {updatedByTockPatronId.toString()}
          </Text>
        ) : null}
        {source ? (
          <Text variant="bodySm">
            <Text variant="bodySmStrong" as="span">
              Source:{' '}
            </Text>
            {source}
          </Text>
        ) : null}
      </Box>
    </Card.Body>
  </Card>
);

export default UserHistoryEventCard;
